import styled from 'styled-components';

interface ContainerBarraProps {
  porcentagem: number;
  colorBar: string;
}

interface ContainerProps {
  height: string;
}

export const Container = styled.div<ContainerProps>`
  width: 200px;
  height: ${(props) => props.height};
  border-radius: 10px;
  box-shadow: inset 0 0 5px #000;
  background-color: #ffffff;
`;

export const ContainerBarra = styled.div<ContainerBarraProps>`
  width: ${(props) => props.porcentagem}%;
  height: 100%;
  background-color: ${(props) => props.colorBar};
  border-radius: 8px;
  transition: width 0.3s ease-in-out;
`;
